/**
 * Ordenacao client-side para o modal SeletorConjuntos.
 *
 * Mesmo padrao de `ordenarUsinasEolicas`: cria array novo (nao muta),
 * usa `localeCompare('pt-BR')` para strings e comparacao numerica para
 * `qtd_usinas` / `potencia_total_mw`. Nulls vao pro fim independente da
 * direcao — comportamento consistente com `ORDER BY ... NULLS LAST` do
 * SQL Postgres usado no backend.
 */
import {
  ColunaOrdenavelConjunto,
  ConjuntoAgregado,
  OrdenacaoConjuntos,
} from 'helper/windx';

function compararStrings(
  a: string | null,
  b: string | null,
  direcao: 'asc' | 'desc',
): number {
  if (a === null && b === null) return 0;
  if (a === null) return 1; // null sempre por ultimo
  if (b === null) return -1;
  const cmp = a.localeCompare(b, 'pt-BR');
  return direcao === 'asc' ? cmp : -cmp;
}

function compararNumeros(a: number, b: number, direcao: 'asc' | 'desc'): number {
  return direcao === 'asc' ? a - b : b - a;
}

const COLUNAS_NUMERICAS: ColunaOrdenavelConjunto[] = [
  'qtd_usinas',
  'potencia_total_mw',
];

export default function ordenarConjuntos(
  conjuntos: ConjuntoAgregado[],
  ordenacao: OrdenacaoConjuntos,
): ConjuntoAgregado[] {
  const { coluna, direcao } = ordenacao;
  const copia = [...conjuntos];
  if (COLUNAS_NUMERICAS.includes(coluna)) {
    copia.sort((a, b) => compararNumeros(
      a[coluna] as number,
      b[coluna] as number,
      direcao,
    ));
  } else {
    copia.sort((a, b) => compararStrings(
      a[coluna] as string | null,
      b[coluna] as string | null,
      direcao,
    ));
  }
  return copia;
}
